/**
 * Redux middleware to automatically reset the idle timer when lastAction.timestamp changes
 * This ensures that user activity properly resets the auto-logout timer
 */
/* eslint-disable-next-line import/no-cycle */
import loginActions from '../actions/loginActionCreators';

// Actions that should NOT reset the idle timer
// These must match the list in storeRegistration.js lastAction reducer
const IDLE_TIMER_IGNORE_ACTIONS = ['DISMISS',
// Notification dismiss shouldn't reset timer
'LOGOUT',
// Logout action itself shouldn't reset timer
'AUTO_LOGOUT_WITH_SAVE' // Auto-logout related actions
];

/**
 * Middleware that watches for changes to lastAction.timestamp and calls idleTimer
 * when it changes (for actions that should reset the timer)
 */
const idleTimerMiddleware = store => next => action => {
  var _stateBefore$lastActi, _stateAfter$lastActio, _stateAfter$login;
  // Get state before the action is processed
  const stateBefore = store.getState();
  const previousTimestamp = (_stateBefore$lastActi = stateBefore.lastAction) === null || _stateBefore$lastActi === void 0 ? void 0 : _stateBefore$lastActi.timestamp;

  // Process the action
  const result = next(action);

  // Get state after the action is processed
  const stateAfter = store.getState();
  const currentTimestamp = (_stateAfter$lastActio = stateAfter.lastAction) === null || _stateAfter$lastActio === void 0 ? void 0 : _stateAfter$lastActio.timestamp;
  const user = (_stateAfter$login = stateAfter.login) === null || _stateAfter$login === void 0 ? void 0 : _stateAfter$login.user;

  // Check if timestamp changed and action is not in ignore list
  const timestampChanged = previousTimestamp !== currentTimestamp;
  const shouldResetTimer = !IDLE_TIMER_IGNORE_ACTIONS.includes(action.type);

  // Only call idleTimer if:
  // 1. Timestamp actually changed
  // 2. Action is not in the ignore list
  // 3. User has auto-logout enabled
  // 4. User exists (not logged out)
  if (timestampChanged && shouldResetTimer && user !== null && user !== void 0 && user.logoutAfterIdleTime) {
    // Dispatch idleTimer to reset the timeout
    store.dispatch(loginActions.idleTimer(user));
  }
  return result;
};
export default idleTimerMiddleware;